import script from "./BaseChartElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseChartElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseChartElement.vue?vue&type=style&index=0&id=7d2e5c4e&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d2e5c4e"]])

export default __exports__